module.exports = __webpack_public_path__ + "img/what-happens-mobile@2x.3b853947.webp";